export default {
  usuario: null
}



// WEBPACK FOOTER //
// ./src/features/auth/store/state.js